export const visit = (vm, at) => {
at({ "en": { "pricingPage": { "detailedTermSelector": { "payMonthly": "Pay Monthly", "payAnnually": "Pay Annually", "commitMonthly": "Commit monthly", "commitAnnually": "Commit annually", "bestValue": "Best Value" } } } });
};